"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersPanelContent = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _swiper = require("swiper");
var _react2 = require("swiper/react");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FilterTypes = require("./FilterTypes");
var _filter = require("../../icons/filter");
var _constants = require("../../utils/constants");
var _ResetButton = require("./ResetButton");
var _useFilterContent = require("../../hooks/useFilterContent");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const {
  filterTypes: constFilterTypes
} = _paulCorePackage.constants;
const FiltersPanelContent = exports.FiltersPanelContent = /*#__PURE__*/(0, _react.memo)(props => {
  const {
    config,
    objectId
  } = props;
  const [activeFilterIds, satActiveFilterIds] = (0, _react.useState)([]);
  (0, _useFilterContent.useFilterContent)({
    config,
    activeFilterIds,
    objectId
  });
  const configWithoutSearch = config.filter(c => c.type !== constFilterTypes.search);
  const handleUpdateActiveFilter = _ref => {
    let {
      filter,
      add = false
    } = _ref;
    satActiveFilterIds(oldActiveFilters => {
      if (add) {
        return oldActiveFilters.concat([filter.id]);
      }
      return oldActiveFilters.filter(id => filter.id !== id);
    });
  };
  const isActiveFilter = filter => {
    if (!activeFilterIds.length || !filter.grouped && !activeFilterIds.includes(filter.id)) {
      return false;
    }
    if (activeFilterIds.includes(filter.id)) {
      return true;
    }
    const activeValues = activeFilterIds.reduce((acc, activeFilterId) => {
      const activeFilter = config.find(configFilter => configFilter.id === activeFilterId);
      return [...acc, ...activeFilter.value];
    }, []);
    return !filter.value.find(value => !activeValues.includes(value));
  };
  const getField = filter => {
    const filterIsActive = isActiveFilter(filter);
    switch (filter.type) {
      case constFilterTypes.button:
        return (
          /*#__PURE__*/
          /** @todo: remove sx after themes */
          _react.default.createElement(_material.Chip, {
            sx: {
              border: '1px solid',
              backgroundColor: filterIsActive ? _constants.colors['main-color-cl-30'] : 'transparent',
              fontWeight: 'bold',
              color: filterIsActive ? _constants.colors['main-color-cl-19'] : _constants.colors['main-color-cl-14'],
              transition: 'all .5s',
              '&:hover': {
                backgroundColor: filterIsActive ? _constants.colors['main-color-cl-30'] : 'transparent'
              }
            },
            color: filterIsActive ? 'primary' : 'default',
            variant: filterIsActive ? 'primary' : 'outlined',
            label: filter.text || /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
              variant: "text",
              sx: {
                fontSize: 'inherit',
                height: 30,
                width: 80
              }
            }),
            onClick: () => handleUpdateActiveFilter({
              filter,
              add: !filterIsActive
            })
          })
        );
      default:
        return null;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_filter.FilterSVG, {
    width: 25,
    height: 20,
    minWidth: 25
  }), /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
    freeMode: true,
    modules: [_swiper.FreeMode, _swiper.Navigation],
    slidesPerView: "auto",
    spaceBetween: 16,
    navigation: false,
    grabCursor: true,
    className: "SwiperLayoutGrid"
  }, configWithoutSearch.map(filter => /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
    key: filter.id,
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, getField(filter)))), /*#__PURE__*/_react.default.createElement(_ResetButton.ResetButton, {
    activeFilterIds: activeFilterIds,
    satActiveFilterIds: satActiveFilterIds
  }));
}, (prev, next) => !!(_paulCorePackage.functions.areEqual(prev.config, next.config) && prev.objectId === next.objectId));
FiltersPanelContent.displayName = 'FiltersPanelContent';
FiltersPanelContent.propTypes = {
  config: _FilterTypes.ConfigType.isRequired,
  objectId: _propTypes.default.string
};
FiltersPanelContent.defaultProps = {
  objectId: 'id'
};